import { INNER_STORE } from './constants'
import { put, get } from './inner-store'
import { refresh } from './refresh'

const refreshOnTime = (): number => {
  return handleRefreshTimeout()
}
const handleRefreshTimeout = (): number => {
  // se utiliza el tiempo indicado al iniciar el módulo en el parametro
  // autoRefreshTime o si no se ha indicado
  // refresca el token cuando lleva 3/4 de su tiempo de vida
  // refresh_expires_in viene en segundos
  const time =
    get(INNER_STORE.autoRefreshTime) ||
    (Number(get(INNER_STORE.auth).refresh_expires_in) / 4) * 3 * 1000

  const id = window.setTimeout(async () => {
    try {
      await refresh()
    } catch {
      // si falla el refresh no hacemos nada y se vuelve a intentar
    } finally {
      handleRefreshTimeout()
    }
  }, time)

  put(INNER_STORE.cancelRefreshOnTime, () => {
    clearTimeout(id)
  })

  return id
}

export { refreshOnTime }
